// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2KHQ9","title":"Header_title__3XGJJ","side":"Header_side__1JZTx"};